import React from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';
import { useRecording } from '../context/RecordingContext';

export const RecordingError: React.FC = () => {
  const { recording, clearError, clearSuccess } = useRecording();

  if (!recording.error && !recording.success) return null;

  const isError = !!recording.error;

  return (
    <div
      className={`fixed top-24 left-1/2 transform -translate-x-1/2 rounded-lg p-4 mb-6 flex items-center gap-3 z-50 w-auto min-w-[300px] max-w-lg shadow-xl ${
        isError
          ? 'bg-red-700 border border-red-500 text-white'
          : 'bg-green-700 border border-green-500 text-white'
      }`}
    >
      {isError ? <AlertCircle size={20} className="shrink-0" /> : <CheckCircle size={20} className="shrink-0" />}
      <p className="text-sm font-medium">{isError ? recording.error : recording.success}</p>
      <button
        onClick={isError ? clearError : clearSuccess}
        className="ml-auto p-1 hover:bg-white/20 rounded-full shrink-0"
      >
        <X size={16} />
      </button>
    </div>
  );
};